import React, { useEffect, useState } from 'react';

import './NcContadorLirerancaInspiradora.css'

const NcContadorLiderancaInspiradora = () => {
    const Infos = {
        estado: 'BRASÍLIA',
        data: '19/06/2024',
        inscricoes: '16 a 26/05',
        regional: 'REGIONAL CENTRO-OESTE E NORTE'
    }

    const [timeRemaining, setTimeRemaining] = useState(calculateTimeRemaining());

    useEffect(()=>{
        const interval = setInterval(() => {
            setTimeRemaining(calculateTimeRemaining());
        }, 1000);
    },[]);

    function calculateTimeRemaining() {
        const data = new Date(Infos.data.split('/').reverse().join('-') + 'T00:00:00-03:00').getTime();
        const agora = new Date().getTime();
        const distancia = data > agora ? data - agora : 0;

        return {
            dias: (Math.floor(distancia / (1000 * 60 * 60 * 24))).toString().padStart(2,'0'),
            horas: (Math.floor((distancia % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).toString().padStart(2,'0'),
            minutos: (Math.floor((distancia % (1000 * 60 * 60)) / (1000 * 60))).toString().padStart(2,'0'),
            segundos: (Math.floor((distancia % (1000 * 60)) / 1000)).toString().padStart(2,'0'),
        };
    }

    return (
        <>
            <div className='NcContadorLiderancaInspiradora-p1'>
                <div className='container'>
                    <div className='col1'>
                        <h2><img src={`${process.env.PUBLIC_URL}/assets/images/NcContadorLirerancaInspiradora/logo-lideranca-inspiradora.svg`} alt="Liderança Inspiradora" /></h2>
                        <h3>O encontro presencial da Academia de Liderança VD em Brasília está chegando!</h3>
                        <p>Quer se conectar com outros<br />
                        líderes e evoluir ainda mais a<br />
                        sua gestão? Então, faça a<br />
                        sua inscrição agora e<br />
                        aproveite tudo desse<br />
                        dia exclusivo!</p>
                    </div>

                    <div className='col2'>
                        <div className="infos">
                            <ul className='info1'>
                                <li><b>{Infos["estado"]}</b></li>
                                <li className='data'>{Infos.data.split('/').slice(0, 2).join('/')}</li>
                                <li>
                                    <p><b>inscrições</b></p>
                                    <p>{Infos["inscricoes"]}</p>
                                </li>
                            </ul>
                            <div className='info2'>{Infos["regional"]}</div>
                        </div>
                        <p className="seta"><img src={`${process.env.PUBLIC_URL}/assets/images/NcContadorLirerancaInspiradora/seta-rosa.svg`} alt="" /></p>
                        <div className="contador">
                            <p className="titulo">Faltam apenas</p>
                            <ul>
                                <li>
                                    <span>DIA{timeRemaining.dias != '01' ? 'S' : ''}</span>
                                    <p>{timeRemaining.dias}</p>
                                </li>
                                <li>
                                    <span>HORA{timeRemaining.horas != '01' ? 'S' : ''}</span>
                                    <p>{timeRemaining.horas}</p>
                                </li>
                                <li>
                                    <span>MIN</span>
                                    <p>{timeRemaining.minutos}</p>
                                </li>
                                <li>
                                    <span>SEG</span>
                                    <p>{timeRemaining.segundos}</p>
                                </li>
                            </ul>
                            <p className="titulo">para o nosso encontro</p>
                        </div>

                        <a className='cta' href="https://academiadeliderancavd.grupoboticario.com.br/assets/documents/ebook-academia.pdf" target='_blank'>CLIQUE AQUI E SAIBA MAIS</a>
                    </div>
                </div>
            </div>

            <div className='NcContadorLiderancaInspiradora-p2'>
                <div className='container'>
                    <h3>Demais datas de encontros presenciais</h3>
                    <p className="seta"><img src={`${process.env.PUBLIC_URL}/assets/images/NcContadorLirerancaInspiradora/seta-azul.svg`} alt="" /></p>

                    <ul>
                        <li>
                            <h4>REGIONAL NORDESTE</h4>
                            <p>Recife/PE <b>12/07</b></p>
                        </li>
                        <li>
                            <h4>EXCLUSIVO ESTADOS MINAS GERAIS E RIO DE JANEIRO</h4>
                            <p>Belo Horizonte/MG <b>13/09</b></p>
                        </li>
                        <li>
                            <h4>REGIONAL SUL</h4>
                            <p>Curitiba/PR <b>04/10</b></p>
                        </li>
                        <li>
                            <h4>EXCLUSIVO ESTADOS SÃO PAULO E ESPÍRITO SANTO</h4>
                            <p>Campinas/SP <b>18/10</b></p>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
}
 
export default NcContadorLiderancaInspiradora;